// 基础信息
export enum CompanyEnum {
  // 客户联系电话
  TELE = '4006-788-887'
}
